import microuniversoApi from 'app/api/microuniversoApi'
import * as corLinearProgressActions from 'app/redux/corLinearProgressSlice';
import store from 'app/redux/store/store';


export const atualizarCorLinearProgress = async () => {
    //const cor = (await microuniversoApi.Filial.obterConfiguracao())?.Cor ?? "#80888a";
    const cor = '#378CCA';
}

(window as any).atualizarCorLinearProgress = atualizarCorLinearProgress
